import { scenesAdapter, SceneState } from './scene.entity';
import { createReducer, on, Action } from '@ngrx/store';
import { scenesActionTypes } from './scene.actions';
import { EntityState } from '@ngrx/entity';
import { DeviceGroup } from './../../../api/models/device-group.model';
import { authActionTypes } from './../../../auth/store/auth.actions';


export const initialState: SceneState = scenesAdapter.getInitialState({
    ids: [],
    loaded: false,
    total: null,
    newlyCreatedScene: null
});

export const scenesReducerObj = createReducer(
    initialState,

    on(scenesActionTypes.setScenesAction, (state, action) => {
        if (action.scenes && action.scenes !== null && action.scenes.length > 0) {
            return scenesAdapter.addAll(action.scenes, {
                ...state,
                loaded: true,
                total: action.scenes && action.scenes !== null ? action.scenes.length : 0
            });
        }
        else {

            return {
                ...state,
                loaded: true,
                total: 0
            };
        }

    }
    ),

    on(authActionTypes.LogOut, (state, action) => {
        // return accountAdapter.removeAll({ ...state, currentAccount:null })
        return scenesAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0
        });
    }),

    on(scenesActionTypes.addSceneSuccess, (state, action) => {

        if (state.entities[action.scene.Id])
            return state;
        else
            return scenesAdapter.addOne(action.scene, {
                ...state,
                total: state.total + 1,
                newlyCreatedScene: action.scene
            });
    }
    ),

    on(scenesActionTypes.deleteSceneSuccess, (state, action) => {
        return scenesAdapter.removeOne(action.sceneId, {
            ...state,
            total: state.total - 1
        });
    }
    ),

    on(scenesActionTypes.updateSceneSuccess, (state, action) => {
        return scenesAdapter.updateOne(action.udpate, state);
    }),

    on(scenesActionTypes.clear, (state, action) => {
        return scenesAdapter.removeAll(state);
    })
);

export function reducer(state: SceneState = initialState, action: Action): SceneState {
    return scenesReducerObj(state, action);
}

export const sceneSelectors = scenesAdapter.getSelectors();
